import './map.css';

import React, { useCallback } from 'react';
import { ICoord } from '../../models/coord.model';
import { IListings } from '../../models/listings.model';
import ListingMarker from './listing-marker';
import MiniListingPreview from './mini-listing-preview';
import { STATUS_OPTIONS } from '../../util/listing-search.constants';
import { IListing } from '../../models/listing.model';

export interface MapResultsProps {
  listings: IListings;
  activePreviewListingId: string;
  zoomLevel: number;
  setActivePreviewListingId(value: string): void;
  openListing(listing: IListing): void;
  getOverlayPixelPositionOffsetWrapper(width: number, height: number, coords: ICoord | undefined): { x: number; y: number; };
  onMouseOverListingMarker(listingId: string): void;
  onMouseOutListingMarker(): void;
}

export const MapResults: React.FC<MapResultsProps> = props => {

  const isActive = useCallback(function (id: string) {
    return props.activePreviewListingId === id ? true : false
  }, [props.activePreviewListingId]);

  return (
    <React.Fragment>
      {props.listings.properties !== undefined && props.listings.properties.map((listing, i) => (
        <ListingMarker
          key={listing.id}
          onMouseOver={props.onMouseOverListingMarker}
          onMouseOut={props.onMouseOutListingMarker}
          fillColor={STATUS_OPTIONS.find(s => s.value === listing.saleOrLease)?.markerColor}
          zoomLevel={props.zoomLevel}
          listing={listing}
          isActive={isActive(listing.id)}
          zIndex={i}
          setActivePreviewListingId={props.setActivePreviewListingId}
          openListing={props.openListing}
        >
          {props.activePreviewListingId === listing.id &&
            <MiniListingPreview
              listing={listing}
              getOverlayPixelPositionOffset={props.getOverlayPixelPositionOffsetWrapper}
              setActivePreviewListingId={props.setActivePreviewListingId}
              onMouseOver={props.onMouseOverListingMarker}
              onMouseOut={props.onMouseOutListingMarker}
            />
          }
        </ListingMarker>
      ))}
    </React.Fragment>
  );
}

export default MapResults;
